import React from 'react'
import { DownArrow } from '../../assets/Shared/Icons/DownArrow/DownArrow'
import { UpArrow } from '../../assets/Shared/Icons/UpArrow/UpArrow'

const buttonReset = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  lineHeight: 0,
}

/** Shared expand/collapse control for tree checkbox UIs (reduces duplicate Sonar blocks). */
export function TreeExpandToggle({ isExpanded, onToggle }) {
  return (
    <button
      type="button"
      style={buttonReset}
      aria-expanded={isExpanded}
      aria-label={isExpanded ? 'Collapse' : 'Expand'}
      onClick={onToggle}
    >
      {isExpanded ? <UpArrow color='#333333' size={14} /> : <DownArrow color='#333333' size={14} />}
    </button>
  )
}
